var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C14.7614 3 17 5.23858 17 8C17 9.44955 16.382 10.7538 15.3965 11.667C16.4964 12.1153 17.5081 12.7796 18.3643 13.6357C20.0521 15.3236 21 17.6131 21 20C21 20.5523 20.5523 21 20 21C19.4477 21 19 20.5523 19 20C19 18.1435 18.2629 16.3626 16.9502 15.0498C15.6374 13.7371 13.8565 13 12 13C10.1435 13 8.36256 13.7371 7.0498 15.0498C5.73705 16.3626 5 18.1435 5 20C5 20.5523 4.55228 21 4 21C3.44772 21 3 20.5523 3 20C3 17.6131 3.94791 15.3236 5.63574 13.6357C6.49169 12.7798 7.50296 12.1153 8.60254 11.667C7.61734 10.7538 7 9.44929 7 8C7 5.23858 9.23858 3 12 3ZM12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e3532dc1f3367688dcfb1fcc20d130df.svg";
export { ForwardRef as ReactComponent };